import { useState, useEffect, useMemo } from "react";
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';

//imported
import { STORAGE_PLANS } from "common/viewContent";
import * as actions from 'store/actions';
import * as Path from 'routes/paths';
import Validation from './Validation';
import LoadingButton from "components/shared/LoadingButton";
import { Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CKEditorField from "components/shared/CKEditorField";
import { formatBytes } from "helpers/common";
import { createStoragePlan, updateStoragePlan, viewStoragePlan } from "store/services/storagePlansService";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppSelectField from "components/shared/FormComponents/AppSelectField";

const AddEdit = ({ dispatch }) => {
	const history = useHistory();
	const { id: editkey } = useParams();

	const [planData, setPlanData] = useState();

	const initialValues = useMemo(() => {
		return {
			plan_name: planData ? planData.plan_name : "",
			storage_size: planData ? planData.storage_size : "",
			price: planData ? planData.price : "",
			duration: planData ? planData.duration : "",
			price_id: planData ? planData.price_id : "",
			product_id: planData ? planData.product_id : "",
			description: planData ? planData.description : "",
			status: planData ? planData.status : "inactive",
		};
	}, [planData]);

	useEffect(() => {
		if (editkey) {
			getData();
		}
	}, [editkey]);

	//get detail
	async function getData() {
		try {
			dispatch(actions.persist_store({ loader: true }));
			let res = await viewStoragePlan(editkey);
			setPlanData(res?.body)
			dispatch(actions.persist_store({ loader: false }));
		} catch (err) {
			dispatch(actions.persist_store({ loader: false }));
			console.log(err);
		}
	}

	// add edit
	const handleSubmit = async (values) => {
		try {
			dispatch(actions.persist_store({ loader: true }));
			if (editkey) {
				let payload = {
					planId: editkey,
					data: values
				}
				await updateStoragePlan(payload);
			} else {
				await createStoragePlan(values);
			}
			history.push(Path.storage_plans_management)
			dispatch(actions.persist_store({ loader: false }));
		} catch (err) {
			console.log(err);
			dispatch(actions.persist_store({ loader: false }));
		}
	}

	return (
		<>
			<Helmet title={STORAGE_PLANS.CURRENT_MODULE} />
			<section className="section">
				<div className="section-header">
					<h1>{STORAGE_PLANS.CURRENT_MODULE}</h1>
					<div className="section-header-breadcrumb">

						<div className="breadcrumb-item"><Link to={Path.storage_plans_management}>Manage Storage Plans</Link></div>
						<div className="breadcrumb-item">Edit Storage Plan</div>
					</div>
				</div>
				{/* {!props.loader && */}
				<div className="section-body">
					<h2 className="section-title">Edit Storage Plan</h2>
					<p className="section-lead">
						On this page you can edit the storage plans.
					</p>
					<Formik
						initialValues={initialValues}
						validationSchema={Validation}
						onSubmit={handleSubmit}
						enableReinitialize
					>
						{({
							values,
							errors,
							touched,
							isSubmitting,
							handleSubmit,
							handleChange,
							handleBlur,
							setFieldValue
						}) => (
							<div className="row mt-sm-4">
								<div className="col-8 col-md-8 col-lg-8 col-sm-12">
									<div className="card">
										<div className="card-body">
											<Form onSubmit={handleSubmit}>
												<Row>
													<div
														className={`form-group col-12`}
													>
														<label>Plan Name</label>
														<AppInputField
															className={`form-control`}
															name="plan_name"
															placeholder={"Plan Name"}
														/>
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Storage Size (MB)</label>
														<AppInputField
															className={`form-control`}
															name="storage_size"
															placeholder={"Storage size (MB)"}
															type="number"
														/>
														{values?.storage_size && (
															<p className="text-muted m-0">{formatBytes(values?.storage_size, "mb", "gb").toFixed(2)} GB</p>
														)}
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Price</label>
														<AppInputField
															className={`form-control`}
															name="price"
															placeholder={"Price"}
															type="number"
														/>
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Duration (Days)</label>
														<AppInputField
															className={`form-control`}
															name="duration"
															placeholder={"Duration"}
															type="number"
														/>
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Stripe Product ID</label>
														<AppInputField
															className={`form-control`}
															name="product_id"
															placeholder={"Stripe Product ID"}
														/>
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Stripe Price ID</label>
														<AppInputField
															className={`form-control`}
															name="price_id"
															placeholder={"Stripe Price ID"}
														/>
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Description</label>
														<CKEditorField
															field="description"
															setFieldValue={setFieldValue}
															value={values.description || ""}
															errors={errors}
														/>
														{errors["description"] && touched["description"] && (
															<p className="invalid-feedback">{errors["description"]}</p>
														)}
													</div>
													<div
														className={`form-group col-12`}
													>
														<label>Status</label>
														<AppSelectField
															className={`form-control`}
															name="status"
															options={[
																{
																	label: "Active",
																	value: "active"
																},
																{
																	label: "Inactive",
																	value: "inactive"
																}
															]}
														/>
													</div>
													<div className="form-group col-12 button-submit">
														<LoadingButton
															type="submit"
															className="btn btn-primary btn-lg"
															loading={isSubmitting}
															disabled={isSubmitting}
														>
															{isSubmitting ? "Please Wait..." : "Save"}
														</LoadingButton>
													</div>
												</Row>
											</Form>
										</div>
									</div>
								</div>
							</div>
						)}
					</Formik>
				</div>
				{/* } */}
			</section>
		</>
	)
}


const mapStateToProps = (state) => {
	return {
	}
};

function mapDispatchToProps(dispatch) {
	return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEdit);